import { addDays, addMonths, format } from 'date-fns';
import ja from 'date-fns/locale/ja';

export const RESERVATION_STATE = {
  Danger: 'Danger',
  Warning: 'Warning',
  Success: 'Success',
};

export const PROCESS_STATE = {
  NotYet: 'NotYet',
  Doing: 'Doing',
  Done: 'Done',
};

export const TICKET_RESERVE_TYPE = {
  Normal: 'Normal',
  Api: 'Api',
};

export const addDay = (date: Date, addCount: number) => {
  return addDays(date, addCount);
};

export const addMonth = (date: Date, addCount: number) => {
  return addMonths(date, addCount);
};

export const formatListDisp = (date: Date) => {
  return format(new Date(date), 'yy/M/d(EEEEE)', {
    locale: ja,
  });
};

export const formatListDisp2 = (date: Date): string => {
  return format(new Date(date), 'yyyy年M月d日 (EEEEE) HH:mm', {
    locale: ja,
  });
};

export const formatDetailsDisp = (date: Date) => {
  return format(new Date(date), 'yyyy年M月d日 (EEEEE)', {
    locale: ja,
  });
};

export const formatTicketDisp = (date: Date) => {
  return format(new Date(date), 'yyyy.MM.dd');
};

export const formatParameterDisp = (date: Date) => {
  return format(new Date(date), 'yyyy-MM-dd');
};

export const formatParameterDisp2 = (date: Date) => {
  return format(new Date(date), 'yyyyMMdd');
};

export const getOptions = (list: any) => {
  return list.map((item: any) => ({
    key: item.key,
    value: item.value,
    text: item.value,
  }));
};
